import React, { useState } from "react";
//outsource
import { Space, Row, Col, Modal, Button, message } from "antd";
import moment from "moment";
//components

import CardWeek from "./component/dialog_card_week";

//redux
import { useDispatch } from "react-redux";
import { addRoster } from "../../../store/roster/roster.action";

const DialogWeekEdit = ({
  selected,
  setSelected,
  data,
  setData,
  open,
  setOpen,
  handleClose,
  lockCurrentWeek,
  afterClose,
}) => {
  // -------------------------- VAR --------------------------
  const fullName = selected?.fullName || "No Select User";
  const dates = selected?.dates || [];
  // -------------------------- STATE --------------------------

  const [loading, setLoading] = useState(false);

  // -------------------------- REDUX --------------------------
  const dispatch = useDispatch();
  // -------------------------- FUNCTION --------------------------

  const handleOk = () => {
    if (data?.length > 0) {
      setLoading(true);
      dispatch(
        addRoster({ datas: data }, () => {
          setLoading(false);
          lockCurrentWeek();
          handleClose();
          message.success("Roster updated");
        })
      );
    }
  };

  // -------------------------- EFFECT --------------------------
  // -------------------------- RENDER --------------------------
  const renderBodyModal = () => {
    return dates?.map((date, index) => {
      return (
        <Col span={24} key={index}>
          <CardWeek
            index={index}
            date={date}
            selected={selected}
            data={data}
            setData={setData}
          />
        </Col>
      );
    });
  };

  const renderFooter = () => {
    const enable = data && data?.length > 0;
    const backgroundColor = enable ? "green" : null;
    return (
      <Col span={24}>
        <Space>
          <Button
            style={{ width: 100 }}
            onClick={handleClose}
            loading={loading}
          >
            Cancel
          </Button>
          <Button
            style={{
              width: 100,
              backgroundColor: backgroundColor,
              border: 0,
            }}
            type="primary"
            onClick={handleOk}
            loading={loading}
            disabled={!enable}
          >
            Ok
          </Button>
        </Space>
      </Col>
    );
  };

  // -------------------------- MAIN --------------------------
  return (
    <Modal
      title={fullName}
      open={open}
      onCancel={handleClose}
      afterClose={afterClose}
      footer={renderFooter()}
      width={650}
    >
      {renderBodyModal()}
    </Modal>
  );
};

export default DialogWeekEdit;
